/* eslint-disable react/no-unknown-property */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from 'react';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  notification,
  Button,
  Tooltip,
  Checkbox,
  Space,
  Tree,
} from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, ReloadOutlined } from '@ant-design/icons';
import * as utility from '../utils/utility';
import * as constants from '../utils/constants';
import { set } from 'lodash';

const treeData = [
  {
    title: 'Super Admin',
    key: 'admin',
  },
  {
    title: 'Admin',
    key: 'super-admin',
  },
  {
    title: 'Dashboard',
    key: 'dashboard',
    children: [
      {
        title: 'Normal User',
        key: 'web-page-without-create-project',
      },
      {
        title: 'Normal User With Create Project',
        key: 'web-page',
      },
    ],
  },
  {
    title: 'Analysis',
    key: 'analysis',
  },
  {
    title: 'Ask Evans',
    key: 'AskEvans',
    children: [
      {
        title: 'Admin',
        key: 'askevans-training-data',
      },
      {
        title: 'Normal User',
        key: 'askevans-normal-user',
      },
    ],
  },
  {
    title: 'Impact Dashboard',
    key: 'Impact-Dashboard',
    children: [
      {
        title: 'Admin',
        key: 'impact-dashboard',
      },

      {
        title: 'Senior Leadership Team',
        key: 'impact-dashboard-slt',
      },
      {
        title: 'Normal User',
        key: 'impact-dashboard-normal-user',
      },
    ],
  },
  {
    title: 'Technical',
    key: 'technical',
    children: [
      {
        title: 'Heat Profile',
        key: 'heat-profile',
      },
      {
        title: 'Coating Record Database',
        key: 'coating-record-db',
      },
      {
        title: 'DCAL Generator',
        key: 'dcal-generators',
        children: [
          {
            title: 'Admin',
            key: 'dcal-generator-master',
          },
          {
            title: 'Normal User',
            key: 'dcal-generator',
          },
        ],
      },
    ],
  },
  {
    title: 'Calibration & Control',
    key: 'Calibration-Control',
    children: [
      {
        title: 'Calibration',
        key: 'calibration-normal-user',
      },
    ],
  },
];

const AddUserModal = (props) => {
  const {
    userModalVisible,
    setUserModalVisible,
    onSave,
    userForm,
    setUserModalLoading,
    disableSendEmail,
    OnSendEmail,
    setDisableSendEmail,
    createUserLoader,
    setCreateUserLoader,
    setIsEdit,
    isEdit,
    OnUpdateUserAccess,
    userName,
    setUserName,
    OnRemoveuserFromGroup,
    OnAdduserToGroup,
    setUserGroup,
    userGroup,
  } = props;
  const [sendEmailLoader, setSendEmailLoader] = useState(false);
  const [newPwdFocused, setNewPwdFocused] = React.useState(false);
  const [confirmPwdFocused, setConfirmPwdFocused] = React.useState(false);
  const [showToolTip, setShowToolTip] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [disabledKeys, setDisabledKeys] = useState([]);
  const [processedTreeData, setProcessedTreeData] = useState(treeData);
  const searchInput = React.useRef(null);
  const [passwordStrength, setPasswordStrength] = useState({ score: 0 });
  const [passwordVisible, setPasswordVisible] = useState(false);

  // Initialize processed tree data on component mount
  useEffect(() => {
    if (userGroup && userGroup.length > 0) {
      processTreeData(userGroup);
    }
  }, []);

  const inputRef = useRef(null);

  const toggleVisibility = () => {
    if (inputRef.current) {
      const pos = inputRef.current.input.selectionStart; // save cursor
      setPasswordVisible(!passwordVisible);
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.input.setSelectionRange(pos, pos); // restore cursor
      }, 0);
    } else {
      setPasswordVisible(!passwordVisible);
    }
  };

  // Password strength evaluation function (returns score 0-5)
  const evaluatePasswordStrength = (password) => {
    let score = 0;
    const pattern = /[-#$.%&@!+=\\*^()?"<>'":|_~`]/;
    if (!password) return 0;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    console.log('score...4', score, password);
    if (pattern.test(password)) score++;
    console.log('score...5', score, password);
    return score; // 0 to 5
  };

  const handlePassword = (e) => {
    const password = e.target.value;
    const regexPattern = /^(?=.*[-\#\$\.\%\&\@\!\+\=\\*])(?=.*[a-zA-Z])(?=.*\d).{8,12}$/;
    if (password.match(regexPattern)) {
      setShowToolTip(false);
    } else {
      setShowToolTip(true);
    }
    setPasswordStrength({ score: evaluatePasswordStrength(password) });
  };

  const handleCancel = () => {
    setIsEdit(false);
    setUserModalVisible(false);
    setDisableSendEmail(false);
    setUserGroup([]);
    setDisabledKeys([]);
    setProcessedTreeData(treeData);
    userForm.resetFields();
  };

  // Function to process tree data and update disabled keys
  const processTreeData = (selectedKeys) => {
    const newDisabledKeys = [];
    const newProcessedTreeData = JSON.parse(JSON.stringify(treeData));

    // Define parent-child relationships for automatic selection
    // const parentChildMap = {
    //   'AskEvans': {
    //     normalUserKey: 'askevans-normal-user',
    //     adminKey: 'askevans-training-data'
    //   },
    //   'dcal-generators': {
    //     normalUserKey: 'dcal-generator',
    //     adminKey: 'dcal-generator-master'
    //   }
    // };

    // // Process each parent node
    // Object.keys(parentChildMap).forEach(parentKey => {
    //   const { normalUserKey, adminKey } = parentChildMap[parentKey];

    //   if (selectedKeys.includes(parentKey)) {
    //     // If parent is selected, automatically select normal user and disable admin
    //     if (!selectedKeys.includes(normalUserKey)) {
    //       selectedKeys.push(normalUserKey);
    //     }
    //     newDisabledKeys.push(adminKey);

    //     // Update the tree data to show admin as disabled
    //     const updateNodeDisabled = (nodes) => {
    //       nodes.forEach(node => {
    //         if (node.key === adminKey) {
    //           node.disabled = true;
    //         } else if (node.children) {
    //           updateNodeDisabled(node.children);
    //         }
    //       });
    //     };
    //     updateNodeDisabled(newProcessedTreeData);
    //   } else {
    //     // If parent is not selected, remove normal user from selection and enable admin
    //     const normalUserIndex = selectedKeys.indexOf(normalUserKey);
    //     if (normalUserIndex > -1) {
    //       selectedKeys.splice(normalUserIndex, 1);
    //     }

    //     // Remove admin from disabled keys
    //     const adminIndex = newDisabledKeys.indexOf(adminKey);
    //     if (adminIndex > -1) {
    //       newDisabledKeys.splice(adminIndex, 1);
    //     }

    //     // Update the tree data to show admin as enabled
    //     const updateNodeEnabled = (nodes) => {
    //       nodes.forEach(node => {
    //         if (node.key === adminKey) {
    //           node.disabled = false;
    //         } else if (node.children) {
    //           updateNodeEnabled(node.children);
    //         }
    //       });
    //     };
    //     updateNodeEnabled(newProcessedTreeData);
    //   }
    // });

    // Special logic for Impact Dashboard
    if (selectedKeys.includes('impact-dashboard')) {
      // If admin is selected, auto-select both senior leadership team and normal user, and disable them
      if (!selectedKeys.includes('impact-dashboard-slt')) {
        selectedKeys.push('impact-dashboard-slt');
      }
      if (!selectedKeys.includes('impact-dashboard-normal-user')) {
        selectedKeys.push('impact-dashboard-normal-user');
      }
      newDisabledKeys.push('impact-dashboard-slt', 'impact-dashboard-normal-user');

      // Update the tree data to show both as disabled
      const updateNodesDisabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-slt' || node.key === 'impact-dashboard-normal-user') {
            node.disabled = true;
          } else if (node.children) {
            updateNodesDisabled(node.children);
          }
        });
      };
      updateNodesDisabled(newProcessedTreeData);
    } else if (selectedKeys.includes('impact-dashboard-slt')) {
      // If senior leadership team is selected, auto-select normal user and disable it
      if (!selectedKeys.includes('impact-dashboard-normal-user')) {
        selectedKeys.push('impact-dashboard-normal-user');
      }
      newDisabledKeys.push('impact-dashboard-normal-user');

      // Update the tree data to show normal user as disabled
      const updateNormalUserDisabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-normal-user') {
            node.disabled = true;
          } else if (node.children) {
            updateNormalUserDisabled(node.children);
          }
        });
      };
      updateNormalUserDisabled(newProcessedTreeData);
    } else {
      // If neither admin nor senior leadership team is selected, enable both
      const seniorLeadershipIndex = newDisabledKeys.indexOf('impact-dashboard-slt');
      if (seniorLeadershipIndex > -1) {
        newDisabledKeys.splice(seniorLeadershipIndex, 1);
      }
      const normalUserIndex = newDisabledKeys.indexOf('impact-dashboard-normal-user');
      if (normalUserIndex > -1) {
        newDisabledKeys.splice(normalUserIndex, 1);
      }

      // Update the tree data to show both as enabled
      const updateNodesEnabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-slt' || node.key === 'impact-dashboard-normal-user') {
            node.disabled = false;
          } else if (node.children) {
            updateNodesEnabled(node.children);
          }
        });
      };
      updateNodesEnabled(newProcessedTreeData);
    }

    setDisabledKeys(newDisabledKeys);
    setProcessedTreeData(newProcessedTreeData);
    return selectedKeys;
  };
  const changePass = (data) => {
    try {
      if (data.newPassword === data.confirmPassword) {
        setCreateUserLoader(true);
        const accessToRemove = [
          'dashboard',
          'technical',
          'AdminSection',
          'Calibration',
          'AskEvans',
        ];
        // Function to extract only leaf nodes (groups without children)
        const extractLeafKeys = (nodes) => {
          let keys = [];
          nodes.forEach((node) => {
            if (!node.children || node.children.length === 0) {
              keys.push(node.key);
            } else {
              keys = keys.concat(extractLeafKeys(node.children));
            }
          });
          return keys;
        };

        // Get all leaf (actual group) names from treeData
        const allLeafGroupKeys = extractLeafKeys(treeData);

        // Filter only leaf nodes from the selected access list
        const validAccess = (data.access || []).filter(
          (item) => allLeafGroupKeys.includes(item) && !accessToRemove.includes(item)
        );

        const postData = {
          userFirstName: data.firstName,
          userLastName: data?.lastName,
          temporaryPassword: data.newPassword,
          email: data.email.toLowerCase().trim(),
          groups: validAccess,
        };

        onSave(postData);
      } else {
        notification.warning({
          message: 'Passwords do not match',
        });
      }
    } catch (err) {
      notification.warning({
        message: 'Something went wrong.',
      });
    }
  };
  const validateEmail = (email) => {
    const regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return regexp.test(email);
  };
  const validatePass = () => {
    userForm.validateFields().then(async (data) => {
      if (data.email === '') {
        notification.warning({
          message: 'Enter email ID to proceed!',
        });
        return;
      }
      if (data.newPassword === '') {
        notification.warning({
          message: 'Enter email  Password to proceed!',
        });
        return;
      }
      if (data.confirmPassword === '') {
        notification.warning({
          message: 'Enter email  confirmPassword to proceed!',
        });
        return;
      }

      // if (validateEmail(data.email.toLowerCase().trim())) {
      //   notification.warning({
      //     message: 'Please enter a valid email ID!'
      //   });

      // }

      setUserModalLoading(true);
      changePass(data);
    });
  };

  const sendEmail = () => {
    setSendEmailLoader(true);
    userForm.validateFields().then(async (data) => {
      const postData = {
        userFirstName: data.firstName,
        userLastName: data?.lastName,
        temporaryPassword: data.newPassword,
        email: data.email.toLowerCase(),
      };
      await OnSendEmail(postData);
    });
  };

  // const updateUserAccess = async () => {
  //   try {
  //     const data = await userForm.validateFields();
  //     setCreateUserLoader(true);
  //     setUserModalLoading(true);

  //     const isWebPageSelected = data.access.includes('web-page');
  //     const isAdminSelected = data.access.includes('admin');
  //     const isAnalysisSelected = data.access.includes('analysis');
  //     const isHeatProfile = data.access.includes('heat-profile');
  //     const isCoatingDb = data.access.includes('coating-record-db');
  //     const isDcalGenerator = data.access.includes('dcal-generator');
  //     const isDcalGeneratorMaster = data.access.includes('dcal-generator-master');

  //     if (isWebPageSelected && !userGroup.includes('web-page')) {
  //       await updateUserGroup('web-page');
  //     } else if (!isWebPageSelected && userGroup.includes('web-page')) {
  //       await removeUserFromGroup('web-page');
  //     }

  //     if (isAdminSelected && !userGroup.includes('admin')) {
  //       await updateUserGroup('admin');
  //     } else if (!isAdminSelected && userGroup.includes('admin')) {
  //       await removeUserFromGroup('admin');
  //     }

  //     if (isAnalysisSelected && !userGroup.includes('analysis')) {
  //       await updateUserGroup('analysis');
  //     } else if (!isAnalysisSelected && userGroup.includes('analysis')) {
  //       await removeUserFromGroup('analysis');
  //     }

  //     if (isHeatProfile && !userGroup.includes('heat-profile')) {
  //       await updateUserGroup('heat-profile');
  //     } else if (!isHeatProfile && userGroup.includes('heat-profile')) {
  //       await removeUserFromGroup('heat-profile');
  //     }

  //     if (isCoatingDb && !userGroup.includes('coating-record-db')) {
  //       await updateUserGroup('coating-record-db');
  //     } else if (!isCoatingDb && userGroup.includes('coating-record-db')) {
  //       await removeUserFromGroup('coating-record-db');
  //     }
  //     if (isDcalGenerator && !userGroup.includes('dcal-generator')) {
  //       await updateUserGroup('dcal-generator');
  //     } else if (!isDcalGenerator && userGroup.includes('dcal-generator')) {
  //       await removeUserFromGroup('dcal-generator');
  //     }

  //     if (isDcalGeneratorMaster && !userGroup.includes('dcal-generator-master')) {
  //       await updateUserGroup('dcal-generator-master');
  //     } else if (!isDcalGeneratorMaster && userGroup.includes('dcal-generator-master')) {
  //       await removeUserFromGroup('dcal-generator-master');
  //     }
  //     setUserName('');
  //     setUserGroup([]);
  //   } catch (error) {
  //     console.error('Error updating user access:', error);
  //   } finally {
  //     setCreateUserLoader(false);
  //     setUserModalLoading(false);
  //   }
  // };

  const updateUserAccess = async () => {
    try {
      const data = await userForm.validateFields();
      setCreateUserLoader(true);
      setUserModalLoading(true);

      // Extract selected keys from the form
      const selectedKeys = data.access || [];

      // Function to extract only leaf nodes (groups without children)
      const extractLeafKeys = (nodes) => {
        let keys = [];
        nodes.forEach((node) => {
          if (!node.children || node.children.length === 0) {
            keys.push(node.key);
          } else {
            keys = keys.concat(extractLeafKeys(node.children));
          }
        });
        return keys;
      };

      // Get all leaf (actual group) names from treeData
      const allLeafGroupKeys = extractLeafKeys(treeData);

      const addGroupsList = [];
      const removeGroupsList = [];

      // Loop through all group keys and update or remove them accordingly
      for (const group of allLeafGroupKeys) {
        if (selectedKeys.includes(group)) {
          if (!userGroup.includes(group)) {
            addGroupsList.push({ group, userName });
          }
        } else {
          if (userGroup.includes(group)) {
            removeGroupsList.push({ group, userName });
          }
        }
      }
      // console.log("Groups to Add:", userGroup);
      // console.log("Groups to Add:", addGroupsList);
      // console.log("Groups to Remove:", removeGroupsList);

      //Call add/remove functions only if needed
      if (addGroupsList.length > 0) await OnAdduserToGroup(addGroupsList);
      if (removeGroupsList.length > 0) await OnRemoveuserFromGroup(removeGroupsList);

      // Reset user info
      setUserName('');
      setUserGroup([]);
    } catch (error) {
      console.error('Error updating user access:', error);
    } finally {
      setCreateUserLoader(false);
      setUserModalLoading(false);
    }
  };
  const updateUserGroup = async (group) => {
    await OnAdduserToGroup({ group, userName });
  };

  const removeUserFromGroup = async (group) => {
    await OnRemoveuserFromGroup({ group, userName });
  };

  const handleFormValuesChange = (_, allValues) => {
    const { firstName, email, access } = allValues;
    const isFormValid =
      firstName &&
      email &&
      access &&
      (!isEdit ||
        (allValues.newPassword &&
          allValues.confirmPassword &&
          allValues.newPassword === allValues.confirmPassword));
    setIsFormValid(isFormValid);
    setPasswordStrength({ score: evaluatePasswordStrength(allValues.newPassword) });
  };

  const handleTreeSelect = (selectedKeys) => {
    // Process the selected keys to implement automatic selection logic
    const processedKeys = processTreeData(selectedKeys);
    userForm.setFieldsValue({ access: processedKeys });
  };

  const generateRandomPassword = () => {
    const getSecureRandomInt = (max) => {
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      return randomBuffer[0] % max;
    };

    // Variable length between 10-14 characters for better security
    const minLength = 12;
    const maxLength = 12;
    const length = minLength + getSecureRandomInt(maxLength - minLength + 1);

    const specials = '-#$.%&@!+=\\*^()?"<>\':|_~`';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';

    let password = [
      specials[getSecureRandomInt(specials.length)],
      specials[getSecureRandomInt(specials.length)],
      lower[getSecureRandomInt(lower.length)],
      lower[getSecureRandomInt(lower.length)],
      upper[getSecureRandomInt(upper.length)],
      upper[getSecureRandomInt(upper.length)],
      numbers[getSecureRandomInt(numbers.length)],
      numbers[getSecureRandomInt(numbers.length)],
    ];

    const all = specials + lower + upper + numbers;
    for (let i = password.length; i < length; i++) {
      password.push(all[getSecureRandomInt(all.length)]);
    }

    for (let i = password.length - 1; i > 0; i--) {
      const j = getSecureRandomInt(i + 1);
      [password[i], password[j]] = [password[j], password[i]];
    }

    const finalPassword = password.join('');
    const hasSpecial = /[-#$.%&@!+=\\*^()?"<>':|_~`]/.test(finalPassword);
    const hasLower = /[a-z]/.test(finalPassword);
    const hasUpper = /[A-Z]/.test(finalPassword);
    const hasNumber = /\d/.test(finalPassword);

    if (!hasSpecial || !hasLower || !hasUpper || !hasNumber || finalPassword.length < 8) {
      return generateRandomPassword();
    }

    return finalPassword;
  };

  const handleGeneratePassword = () => {
    const pwd = generateRandomPassword();
    userForm.setFieldsValue({
      newPassword: pwd,
      confirmPassword: pwd,
    });
    setShowToolTip(false);
    setPasswordStrength({ score: evaluatePasswordStrength(pwd) });
    setPasswordVisible(true);
  };

  return (
    <>
      <Modal
        width={750}
        className="quality-modal"
        title={isEdit ? 'Edit User Access' : 'Create User'}
        centered
        visible={userModalVisible}
        footer={
          isEdit
            ? [
                <Button key="submit1" type="primary" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  key="submit2"
                  loading={createUserLoader}
                  type="primary"
                  disabled={createUserLoader}
                  onClick={() => updateUserAccess()}
                >
                  Update
                </Button>,
              ]
            : [
                <Button key="submit3" type="primary" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  key="submit4"
                  loading={!disableSendEmail && createUserLoader}
                  type={disableSendEmail ? 'default' : 'primary'}
                  disabled={disableSendEmail}
                  onClick={() => validatePass()}
                >
                  Create
                </Button>,
                <Button
                  key="submit5"
                  loading={sendEmailLoader}
                  type={!disableSendEmail ? 'default' : 'primary'}
                  disabled={!disableSendEmail}
                  onClick={() => sendEmail()}
                >
                  Email login details
                </Button>,
              ]
        }
      >
        <div className="signup-form">
          <Form
            id="create-user-form"
            name="basic"
            layout="vertical"
            autoComplete="off"
            form={userForm}
            initialValues={{
              remember: true,
            }}
            onValuesChange={handleFormValuesChange}
            onFinish=""
          >
            <Row gutter={16}>
              <Col lg={12}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your First Name.',
                    },
                  ]}
                  normalize={(value) => utility.trimSpacesInValues(value)}
                >
                  <Input
                    size="large"
                    placeholder="Enter First Name"
                    maxLength={25}
                    disabled={disableSendEmail || isEdit}
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[
                    {
                      required: false,
                      message: 'Please enter your Last Name.',
                    },
                  ]}
                  normalize={(value) => utility.trimSpacesInValues(value)}
                >
                  <Input
                    size="large"
                    placeholder="Enter Last Name"
                    maxLength={25}
                    disabled={disableSendEmail || isEdit}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter your Email.',
                },
                {
                  pattern: true ? constants.EMAIL_PATTERN : undefined,
                  message: 'Provide a valid Email.',
                },
              ]}
              normalize={(value) => utility.trimSpacesInValues(value)}
            >
              <Input size="large" placeholder="Enter Email" disabled={disableSendEmail || isEdit} />
            </Form.Item>
            {!isEdit && (
              <>
                <Tooltip
                  visible={newPwdFocused && showToolTip}
                  title={
                    <>
                      <p align="left">
                        <b>Requirements:</b>
                      </p>
                      <ul align="left">
                        <li align="left">8-character minimum length</li>
                        <li align="left">Contains at least 1 number</li>
                        <li align="left">Contains at least 1 lowercase letter</li>
                        <li align="left">Contains at least 1 uppercase letter</li>
                        <li align="left">
                          Contains at least 1 special character from the following set, or a
                          non-leading, non-trailing space character.
                        </li>
                        <p align="left">
                          {'^ $ * . [ ] { } ( ) ? - " ! @ # % & /  , > < \' : ; | _ ~ ` + ='}
                        </p>
                      </ul>
                    </>
                  }
                  placement="topLeft"
                >
                  <Form.Item
                    name="newPassword"
                    style={{ marginBottom: 22 }}
                    rules={[{ required: true, message: 'Please enter New Password.' }]}
                  >
                    <Input
                      ref={inputRef}
                      size="large"
                      className="password-icon"
                      placeholder="Password"
                      type={passwordVisible ? 'text' : 'password'}
                      autoComplete="new-password"
                      disabled={disableSendEmail}
                      onChange={(e) => {
                        handlePassword(e);
                        setPasswordVisible(false); // manual typing → mask
                      }}
                      onFocus={() => setNewPwdFocused(true)}
                      onBlur={() => setNewPwdFocused(false)}
                      suffix={
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {passwordVisible ? (
                            <EyeOutlined
                              style={{ color: 'grey', cursor: 'pointer' }}
                              onClick={toggleVisibility}
                            />
                          ) : (
                            <EyeInvisibleOutlined
                              style={{ color: 'grey', cursor: 'pointer' }}
                              onClick={toggleVisibility}
                            />
                          )}
                          <ReloadOutlined
                            style={{ color: 'grey', marginLeft: 8, cursor: 'pointer' }}
                            onClick={handleGeneratePassword}
                            title="Generate random password"
                          />
                        </span>
                      }
                    />
                  </Form.Item>

                  {/* Dotted password strength meter */}
                  {userForm.getFieldValue('newPassword')?.length > 0 && (
                    <div
                      style={{
                        marginBottom: 18,
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: 8,
                        marginLeft: 8,
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((dot) => (
                        <span
                          key={dot}
                          style={{
                            display: 'inline-block',
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            marginRight: 4,
                            background:
                              passwordStrength.score >= dot
                                ? passwordStrength.score <= 2
                                  ? '#ff4d4f' // weak = red
                                  : passwordStrength.score === 3 || passwordStrength.score === 4
                                  ? '#faad14' // medium = orange
                                  : '#52c41a' // strong = green
                                : '#e0e0e0', // empty = gray
                            transition: 'background 0.3s',
                          }}
                        />
                      ))}
                      <span
                        style={{
                          marginLeft: 8,
                          color:
                            passwordStrength.score <= 2
                              ? '#ff4d4f'
                              : passwordStrength.score <= 4
                              ? '#faad14'
                              : '#52c41a',
                          fontWeight: 500,
                        }}
                      >
                        {passwordStrength.score === 0
                          ? ''
                          : passwordStrength.score <= 2
                          ? 'Weak'
                          : passwordStrength.score <= 4
                          ? 'Medium'
                          : 'Strong'}
                      </span>
                    </div>
                  )}
                </Tooltip>
                <Tooltip
                  visible={confirmPwdFocused && showToolTip}
                  title={
                    <>
                      <p align="left">
                        <b>Requirements:</b>
                      </p>
                      <ul align="left">
                        <li align="left">8-character minimum length</li>
                        <li align="left">Contains at least 1 number</li>
                        <li align="left">Contains at least 1 lowercase letter</li>
                        <li align="left">Contains at least 1 uppercase letter</li>
                        <li align="left">
                          Contains at least 1 special character from the following set, or a
                          non-leading, non-trailing space character.
                        </li>
                        <p align="left">
                          {'^ $ * . [ ] { } ( ) ? - " ! @ # % & /  , > < \' : ; | _ ~ ` + ='}
                        </p>
                      </ul>
                    </>
                  }
                  placement="topLeft"
                >
                  <Form.Item
                    name="confirmPassword"
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm your password.',
                      },
                      {
                        pattern: true ? constants.PASSWORD_VALIDATION : undefined,
                        message: 'Password does not meet password policy rules',
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      className="password-icon"
                      placeholder="Confirm New Password"
                      iconRender={(visibility) =>
                        visibility ? (
                          <EyeOutlined style={{ color: 'grey' }} />
                        ) : (
                          <EyeInvisibleOutlined style={{ color: 'grey' }} />
                        )
                      }
                      autoComplete="new-password"
                      disabled={disableSendEmail}
                      onChange={(e) => handlePassword(e)}
                      onFocus={() => setConfirmPwdFocused(true)}
                      onBlur={() => setConfirmPwdFocused(false)}
                    />
                  </Form.Item>
                </Tooltip>
              </>
            )}

            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              className="mb-0"
              label="Access"
              name="access"
              rules={[
                {
                  required: true,
                  message: 'At least one Access is required.',
                },
              ]}
            >
              <Tree
                className="user-access-tree"
                checkable
                treeData={processedTreeData}
                onCheck={handleTreeSelect}
                defaultCheckedKeys={userGroup}
                disabledKeys={disabledKeys}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default AddUserModal;
